import React, { useState, useContext, useEffect } from "react";
import styles from "./Faqs.module.css";
import { AiOutlineArrowDown, AiOutlineArrowUp } from "react-icons/ai";
import { Link } from "react-router-dom";
import { LanguageContext } from "../../Component/LanguageContext/LanguageContext.jsx";
import axios from "axios";

const Faqs = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const [faqData, setFaqData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(0);
  const { direction } = useContext(LanguageContext);
  const isRTL = direction === "rtl";
  const marketingBackendUrl = import.meta.env.VITE_MARKETING_BACKEND_URL;
  const itemsPerPage = 7;

  useEffect(() => {
    const fetchFaqs = async () => {
      try {
        const response = await axios.get(
          `${marketingBackendUrl}/maflam/homepagefaqs`
        );
        // Sort by displayOrder and filter active ones
        const sortedData = response.data
          .filter((faq) => faq.isActive)
          .sort((a, b) => a.displayOrder - b.displayOrder);
        setFaqData(sortedData);
        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };

    fetchFaqs();
  }, []);

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error loading data</p>;

  const handleToggle = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const totalPages = Math.ceil(faqData.length / itemsPerPage);
  const startIndex = currentPage * itemsPerPage;
  const visibleFaqs = faqData.slice(startIndex, startIndex + itemsPerPage);

  const handleScroll = () => {
    setCurrentPage((prevPage) => {
      const nextPage = (prevPage + 1) % totalPages;
      return nextPage;
    });
    setActiveIndex(null); // Reset active item when scrolling
  };

  const isLastPage = currentPage === totalPages - 1;

  return (
    <div className={styles.faqContainer}>
      <Link style={{ fontSize: "36px" }} to="/home/faqs">
        {isRTL ? "الأسئلة الشائعة" : "FAQ"}
      </Link>
      <div className={styles.faqList}>
        {visibleFaqs.map((item, index) => (
          <div
            key={index}
            className={`${styles.faqItem} ${
              activeIndex === index ? styles.active : ""
            }`}
            onClick={() => handleToggle(index)}
          >
            <div className={styles.question}>
              <span> {activeIndex === index ? "-" : "+"}</span>{" "}
              <span>{isRTL ? item.questionArab : item.questionEng}</span>
            </div>
            <div
              className={`${styles.answer} ${
                activeIndex === index ? styles.showAnswer : ""
              }`}
            >
              {isRTL ? item.answerArab : item.answerEng}
            </div>
          </div>
        ))}
        {faqData.length > itemsPerPage && (
          <div className={styles.arrowcontainer}>
            <button className={styles.arrowButton} onClick={handleScroll}>
              {isLastPage ? (
                <AiOutlineArrowUp size={40} />
              ) : (
                <AiOutlineArrowDown size={40} />
              )}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default Faqs;
